export default "__VITE_ASSET__ovUM382V__"